import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentSearchDialogContext,
  ComponentSearchDialogInitialState,
} from ".";

export const ComponentSearchDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ComponentSearchDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentSearchDialogContext.Provider value={context}>
      {children}
    </ComponentSearchDialogContext.Provider>
  );
};
